import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#EBEBEB",
  d: "M22.867.5H3.133A2.633 2.633 0 0 0 .5 3.133v11.734A2.633 2.633 0 0 0 3.133 17.5h19.734a2.633 2.633 0 0 0 2.633-2.633V3.133A2.633 2.633 0 0 0 22.867.5Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#007BC4",
  d: "M21.028 6.866a.692.692 0 0 1 .35.102.582.582 0 0 1 .228.257.507.507 0 0 1 .03.326.552.552 0 0 1-.178.286.667.667 0 0 1-.326.151.71.71 0 0 1-.367-.034.625.625 0 0 1-.283-.21.516.516 0 0 1-.055-.533.572.572 0 0 1 .142-.184.653.653 0 0 1 .211-.122.71.71 0 0 1 .248-.04m-12.593.031v1.22h-.88v-.494H5.44v1.223h1.922v.693H5.44v1.233h2.116v-.494h.879v1.222H4v-.727h.487v-3.15H4v-.725zm3.1 3.248 1.419-3.247h.541l-2.057 4.624h-.567L8.803 6.897h1.327zm3.086-1.032V7.458h2.767c.463 0 .727.07.907.216a.74.74 0 0 1 .196.262.666.666 0 0 1 .056.31.82.82 0 0 1-.243.625c-.17.158-.422.243-.899.243h-2.784zm5.166 2.387-1.83-1.878a1.546 1.546 0 0 0 1.003-.442c.255-.258.386-.596.364-.94a1.112 1.112 0 0 0-.088-.51 1.23 1.23 0 0 0-.313-.433c-.323-.27-.79-.398-1.535-.398h-3.521v4.601h.753V9.674h2.497L18.86 11.5zm1.808-.62c0 .27.126.38.405.504v.116h-1.888v-.116c.28-.123.405-.234.405-.504V9.118c0-.238-.048-.37-.405-.582v-.115h1.483z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }